/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var MediaAudioMicAIcon20Light = forwardRef('MediaAudioMicAIcon20Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10 1a4 4 0 0 0-4 4v5a4 4 0 0 0 8 0V5a4 4 0 0 0-4-4ZM7 5a3 3 0 0 1 6 0v5a3 3 0 1 1-6 0V5Z" }),
        React.createElement("path", { d: "M4.5 8a.5.5 0 0 1 .5.5V10a5 5 0 0 0 10 0V8.5a.5.5 0 0 1 1 0V10a6 6 0 0 1-5.5 5.98V18h3a.5.5 0 0 1 0 1h-7a.5.5 0 0 1 0-1h3v-2.02A6 6 0 0 1 4 10V8.5a.5.5 0 0 1 .5-.5Z" })));
});
